import React, { useContext } from 'react';
import StyledContainer from './StyledContainer';
import ButtonLibras from './ButtonLibras';
import ButtonAudioDesc from './ButtonAudioDesc';
import StylesContext from '../context/StylesContext';
import useAudioDescBtn from '../hooks/useAudioDescBtn';

const MainButtonsContainer = () => {
  const { styles } = useContext(StylesContext);
  const handleClick = useAudioDescBtn({urlId: styles.urlId});

  return (
    <StyledContainer className='buttons_container'>
      <StyledContainer
        id='button_audioDesc'
        className='button_wrapper'
        onClick={handleClick}
      >
        <ButtonAudioDesc
          fillCircleBtn={ styles.btnBgColor}
          circleBorderColor={ styles.btnCircleColor }
          fillSymbolBtn={ styles.btnColor}
        />
      </StyledContainer>
      <StyledContainer id='button_libras' className='button_wrapper'>
        <ButtonLibras
          fillCircleBtn={ styles.btnBgColor}
          circleBorderColor={ styles.btnCircleColor }
          fillSymbolBtn={ styles.btnColor}
        />
      </StyledContainer>      
    </StyledContainer>
  )
}

export default MainButtonsContainer;